import React from 'react'
import {useSelector} from "react-redux";
import AssetFactory from './assets/AssetFactory'
import StockExchangeDetailInfo from "../portfolioTransactions/stockexchange/StockExchangeDetailInfo";
import AssetDetailSkeleton from './AssetDetailSkeleton';

import './Assets.less'

const Assets = ({assets, onEdit = () => {}, onDelete=()=>{}}) => {
    const {
        selectedAsset = {},
        assetDetails = {},
        loadingDetails = false
    } = useSelector(state => state.assets);

    const renderedAssets = assets.map((asset) => AssetFactory.build(asset, onEdit, onDelete));

    const renderAssetInfo = () => {
        if (selectedAsset?.id) {
            const detailInfo = assetDetails[selectedAsset.id];

            if (loadingDetails) {
                return <AssetDetailSkeleton />;
            }

            if (detailInfo) {
                return <StockExchangeDetailInfo detailInfo={detailInfo} />;
            }

            return <div>Нет детальной информации</div>;
        }

        return <div>Выберите актив для просмотра детальной информации</div>;
    }

    return (
        <div>
            <div className='ip-assets'>
                {renderedAssets}
            </div>
            <div className='ip-assets-info'>
                {renderAssetInfo()}
            </div>
        </div>
    )
}

export default Assets;
